import {
    initialiseLogger,
    type InitializeResult,
    initScheduledJobsRunner,
    LoadRum24x7,
    onWindowResize,
    scrollbarWidthUnits,
    setDebugMode,
    verticalHeightUnits,
} from '@omnia/ui/src/lib'
import { gtm } from '@/web/common/services/gtm/gtm.service'

/**
 * Handles running anything that must be ran AFTER initial data is available but BEFORE <App /> is rendered
 */
export const init = (occConfigurationApi: InitializeResult) => {
    // Create logger always as first step
    initialiseLogger(occConfigurationApi?.loggingConfiguration || [])

    // A checker for scheduled jobs in FE
    initScheduledJobsRunner()
    // Generate vertical height units
    verticalHeightUnits()
    scrollbarWidthUnits()

    // const isProd = process.env.production // Leaving in case we need it in the future
    // Code to run every time window resizes
    onWindowResize(() => {
        verticalHeightUnits()
        scrollbarWidthUnits()
    })

    setDebugMode()

    // If we want to load captcha script programmatically instead of in the template
    // if (occConfigurationApi.recaptcha.siteKey)
    //     loadScript('recaptchaScript', 'https://www.google.com/recaptcha/api.js')

    // Load RUM
    if (occConfigurationApi?.rumId) LoadRum24x7(occConfigurationApi.rumId)

    const rootDiv = document.getElementById('root')
    if (rootDiv) {
        // Adding a country class to root DIV for all conditional CSS
        rootDiv.className = occConfigurationApi?.country
        gtm.initializeGoogleTags(occConfigurationApi?.gtmId)
    }
}
